import React, { FC, PropsWithChildren } from 'react';
import { H3 as Text } from './styles';
import { useTheme } from '@emotion/react';
import { Colors } from 'theme/colors';

export interface H3Props {
    variant?: keyof Colors;
    center?: boolean;
    className?: string;
    noMargin?: boolean;
}

const H3: FC<PropsWithChildren<H3Props>> = ({ children, variant = 'black', center, className, noMargin }) => {
    const theme = useTheme();
    const color = theme.colors[variant];

    return (
        <Text color={color} center={center} className={className} noMargin={noMargin}>
            {children}
        </Text>
    );
};

export default H3;
